<template>
  <p>
    El radar de capa límite y troposfera (Boundary Layer and Tropospheric Radar,
    BLTR) es un perfilador de vientos monoestático de 49,92 MHz (l56, 0 m) que
    consta de tres conjuntos de antenas fabricado por Genesis Software Pty Ltd.
    El BLTR opera utilizando la técnica de antena espaciada (SA), que
    proporciona las componentes zonal, meridional y vertical del viento con una
    resolución vertical de 75 m. Debido a su frecuencia operativa, es
    principalmente sensible a mecanismos de dispersión Bragg. Por ello mediante
    un mayor análisis también es capaz de detectar ecos de precipitación durante
    eventos convectivos causados por grandes gotas de lluvia.
  </p>

  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/radar-bltr.webp"
    alt="Radar BLTR"
  />

  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>UU componente de viento zonal (m/s)</li>
    <li>VV componente de viento meridional (m/s)</li>
    <li>WW componente de viento vertical (m/s)</li>
  </List>

  <p>
    <b>Datos disponibles en: </b> <br />
    Cluster - IGP
  </p>

  <p>
    <b>Marca y modelo: </b> <br />
    Genesis Software Pty Ltd.
  </p>

  <p>
    <b>País: </b> <br />
    Australia.
  </p>

  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a
      href="https://www.gsoft.com.au/productsandservices/radarsystems"
      target="_blank"
      >https://www.gsoft.com.au/productsandservices/radarsystems</a
    >
  </p>

  <p>
    <b>Responsable: </b> <br />
    cdelcastillo@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  components: { List },
};
</script>
